import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_dashboard/security/')({
  staticData: {
    domain: 'iam',
  },
  component: lazyRouteComponent(() => import('./index.component'), 'SecurityComponent'),
});
